import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faSearch,
  faChevronLeft,
  faChevronRight,
  faUndo,
  faRedo,
  faTimes,
  faGripLinesVertical,
  faCog,
  faChevronUp,
  faChevronDown,
  faTrash,
  faArrowLeft,
  faArrowRight,
  faSignOutAlt,
  faInfoCircle,
  faSortNumericDown,
  faQuestionCircle,
  faPlus,
  faMinus,
  faExclamationTriangle,
  faSort,
  faSortUp,
  faSortDown,
  faSearchPlus,
  faSearchMinus
} from "@fortawesome/free-solid-svg-icons";

library.add(faSearch);
library.add(faChevronUp);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faGripLinesVertical);
library.add(faTimes);
library.add(faUndo);
library.add(faRedo);
library.add(faCog);
library.add(faTrash);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faSignOutAlt);
library.add(faInfoCircle);
library.add(faPlus);
library.add(faMinus);
library.add(faExclamationTriangle);
library.add(faSortNumericDown);
library.add(faQuestionCircle);
library.add(faSort);
library.add(faSortUp);
library.add(faSortDown);
library.add(faSearchMinus);
library.add(faSearchPlus);

Vue.component("fa-icon", FontAwesomeIcon);
